// Styles
import '../../styles/checkout.scss';

try {
  function docReady(fn) {
  // see if DOM is already available
      if (document.readyState === "complete" || document.readyState === "interactive") {
          // call on next available tick
          setTimeout(fn, 1);
      } else {
          document.addEventListener("DOMContentLoaded", fn);
      }
  }

  var stringToHTML = function (str) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(str, 'text/html');
      return doc.body;
  };

  docReady(function() {
    document.querySelector("[data-modal='policy-privacy-policy']").addEventListener('click', function(){
    const observer = new MutationObserver(function() {
        var privacyPolicyContainer = document.querySelector('.modal__content.text-container');
        var privacyPolicyContent = document.querySelector('.modal__iframe');
        var selectedPrivacy;
        var completePrivacy;

        if ( privacyPolicyContainer && privacyPolicyContent ) {
            fetch(privacyPolicyContent.src).then(function (response) {
            // The API call was successful!
            return response.text();
            }).then(function (html) {
            // This is the HTML from our response as a text string
            completePrivacy = stringToHTML(html);
            if(window.location.origin == 'https://us.villari.it') {
                selectedPrivacy = completePrivacy.querySelector('#US');
            } else if (window.location.origin == 'https://jp.villari.it') {
                selectedPrivacy = completePrivacy.querySelector('#JP');
            } else {
                selectedPrivacy = completePrivacy.querySelector('#EU');
            }
            privacyPolicyContent.style.display = 'none';
            var newContainer = document.createElement('div');
            newContainer.classList.add('privacy-popup');
            newContainer.appendChild(selectedPrivacy);
            privacyPolicyContainer.appendChild(newContainer);
            }).catch(function (err) {
            // There was an error
            console.warn('Something went wrong.', err);
            });


        observer.disconnect();
        }
    });
    observer.observe(document.body, {subtree: true, childList: true, subtree: true});
    });

  });

} catch (error) {
  console.error(error);
}
